import React from "react";
import BrandHeader from "../components/BrandHeader";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { LogIn, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const signInWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background">
      <BrandHeader />
      <main className="mano-container-narrow py-20">
        <div className="mb-10">
          <div className="inline-flex items-center gap-2 rounded-full border border-border/70 bg-card px-3 py-1 text-xs text-muted-foreground">
            <ShieldCheck size={12} /> Staff access only
          </div>
          <h1 className="font-display font-semibold text-3xl sm:text-4xl tracking-tight mt-4">Sign in with your work Google account</h1>
          <p className="text-muted-foreground mt-3 leading-relaxed">
            Access to the admin console is restricted to registered clinicians and platform administrators. All access is logged.
          </p>
        </div>

        <Card className="mano-card">
          <CardContent className="p-8">
            <Button
              size="lg"
              onClick={signInWithGoogle}
              className="rounded-full px-8 w-full sm:w-auto mano-lift"
              data-testid="admin-google-signin"
            >
              <LogIn size={16} /> Continue with Google
            </Button>
            <p className="text-xs text-muted-foreground mt-6">
              First-time sign-in with an unregistered account defaults to respondent access. Contact your platform admin for role elevation.
            </p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
